import React from "react";
import Review1 from '../../../images/review1.png'
import Review2 from '../../../images/review2.png'
import Review3 from '../../../images/review3.png'

const ReviewBar = (props) => {

  return (
    <div className="ReviewBar-sec">
        <div className="box">
          <img src={Review1} alt="Google Reviews3 Bentley Hurst" />
        </div><br />
        <div className="box">
          <img src={Review2} alt="Google Reviews Bentley Hurst" />
        </div><br />
        <div className="box">
          <img src={Review3} alt="Google Reviews2 Bentley Hurst" />
        </div>
    </div>

  )
}

export default ReviewBar
